import React from 'react';

import { flagStyles } from '../settings';

const SvgPM = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4272px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgPM;
